import { AbandonedCartComponent } from './abandoned.cart.report/abandoned.cart.report.component';
import { AutomatedBillingReportComponent } from './automated.billing.report/automated.billing.report.component';
import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TOSReportComponent } from './tos.report/tos.report.component';
import { GracePeriodReportComponent } from './grace.period.report/grace.period.report.component';
import { BillingReportComponent } from './billing.report/billing.report.component';
import { InvoiceReportComponent } from './invoice.report/invoice.report.component';
import { CreditReportComponent } from './credit.report/credit.report.component';
import { DiscountReportComponent } from './discount.report/discount.report.component';
import { HoldReportComponent } from './hold.report/hold.report.component';
import { TOSMACWhitelistComponent } from './tos-mac-whitelist/tos.mac.whitelist.component';
import { TOSPhoneWhitelistComponent } from './tos-phone-whitelist/tos.phone.whitelist.component';
import { TOSAddressWhitelistComponent } from './tos-address-whitelist/tos.address.whitelist.component';


const MonitoringRouting: Routes = [
    // login view
    {

        path: 'monitoring', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: TOSReportComponent },
            { path: 'tos', component: TOSReportComponent },
            { path: 'grace-period', component: GracePeriodReportComponent },
            { path: 'billing-report', component: BillingReportComponent },
            { path: 'invoice-report', component: InvoiceReportComponent },
            { path: 'credit-report', component: CreditReportComponent },
            { path: 'discount-report', component: DiscountReportComponent },
            { path: 'automated-billing', component: AutomatedBillingReportComponent },
			{ path: 'abandoned-cart', component: AbandonedCartComponent },
            { path: 'tos-mac-whitelist', component: TOSMACWhitelistComponent },
            { path: 'tos-phone-whitelist', component: TOSPhoneWhitelistComponent },
            { path: 'tos-address-whitelist', component: TOSAddressWhitelistComponent },
			{ path: 'hold-report', component: HoldReportComponent },
            // handle all other routes
            { path: '**', component: TOSReportComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(MonitoringRouting)],
    exports: [RouterModule]
})
export class MonitoringRoutingModule { }
